import { render, staticRenderFns } from "./SarjanaForm.vue?vue&type=template&id=f50dafec&scoped=true"
import script from "./SarjanaForm.vue?vue&type=script&lang=js"
export * from "./SarjanaForm.vue?vue&type=script&lang=js"
import style0 from "./SarjanaForm.vue?vue&type=style&index=0&id=f50dafec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50dafec",
  null
  
)

export default component.exports